import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLinkWithHref } from "@angular/router";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLinkWithHref],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();

  // TODO: Quando criar tabela no db "EMPRESA" mover essas constantes para lá e puxar via serviço api
  emailSupport: string = 'concurso@recrutamentobrasil.com.br';
  phoneSupport: string = '+55 (11) 3164-0969';
}
